import { render, staticRenderFns } from "./CustomPopover.vue?vue&type=template&id=797ef256&scoped=true&"
import script from "./CustomPopover.vue?vue&type=script&lang=js&"
export * from "./CustomPopover.vue?vue&type=script&lang=js&"
import style0 from "./CustomPopover.vue?vue&type=style&index=0&id=797ef256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ef256",
  null
  
)

export default component.exports